import axios from 'axios';

const gateway = process.env.VUE_APP_SKG_GATEWAY;
const entrypoint = '/api/v1/datamodel';

const store = {
    state: {
        properties: [],
        types: [],
    },

    getters: {
        getProperties: (state) => state.properties || [],
        getTypes: (state) => state.types || [],
    },

    actions: {
        async flush({ commit, getters }) {
            return new Promise((resolve, reject) => {
                commit('clear_all');
            });
        },
        async fetchAll({ dispatch }) {
            dispatch('fetchProperties');
            dispatch('fetchTypes');
        },
        async fetchTypes({ commit, getters }) {
            return new Promise((resolve, reject) => {
                if (getters.getProperties.length > 0) {
                    resolve();
                    return;
                }

                axios
                    .get(`${gateway}${entrypoint}/types`)
                    .then((res) => {
                        commit('set_types', res.data);
                        resolve();
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(e);
                    });
            });
        },
        async fetchProperties({ commit, getters }) {
            return new Promise((resolve, reject) => {
                if (getters.getProperties.length > 0) {
                    resolve();
                    return;
                }

                axios
                    .get(`${gateway}${entrypoint}/properties`)
                    .then((res) => {
                        commit('set_properties', res.data);
                        resolve();
                    })
                    .catch((e) => {
                        console.log(e);
                        reject(e);
                    });
            });
        },
    },
    mutations: {
        flush(state) {
            state.properties = [];
            state.types = [];
        },
        set_properties(state, data) {
            state.properties = data;
        },
        set_types(state, data) {
            state.types = data;
        },
    },
};

export default {
    ...store,
    namespaced: true,
};
